import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Card, CardMedia, useTheme, Grid, Box } from '@mui/material';
import boardPlaceholderCollection from '../../assets/images/boardPlaceholderCollection.png';
import boardPlaceholderFavourite from '../../assets/images/boardPlaceholderFavourite.png';

const RecipeCollectionCard = ({
  boardID,
  title,
  coverImageUrl,
  onClickBoard,
  isFavourite,
}) => {
  const theme = useTheme();

  const boardPlaceholder = isFavourite
    ? boardPlaceholderFavourite
    : boardPlaceholderCollection;

  const hasTitle = !!title;
  const imgClassNames = classNames('narrowEndUserContentEntryCardImage', {
    withFilter: hasTitle,
  });

  return (
    <div style={{ position: 'relative' }}>
      <Card
        onClick={(ev) => {
          ev.preventDefault();
          onClickBoard(boardID);
        }}
        className="shared-programme-card"
        sx={{
          width: 166,
          height: 155,
          minWidth: 166,
          borderRadius: '15px',
          margin: '6px',
          flexShrink: 0,
        }}
        style={{ backgroundColor: theme.palette.primary.cardBackground }}>
        <Box sx={{ position: 'relative' }}>
          {hasTitle && coverImageUrl && (
            <Grid item xs={12}>
              <CardMedia
                component="img"
                className={imgClassNames}
                image={coverImageUrl || boardPlaceholder}
                alt=""
              />
              <div className="narrowEndUserContentEntryCardText">{title}</div>
            </Grid>
          )}
          {!hasTitle && coverImageUrl && (
            <Grid item xs={12}>
              <CardMedia
                component="img"
                className={imgClassNames}
                image={coverImageUrl || boardPlaceholder}
                alt=""
              />
              <div className="narrowEndUserContentEntryCardText">{title}</div>
            </Grid>
          )}
          {hasTitle && !coverImageUrl && (
            <Grid item xs={12}>
              <CardMedia
                component="img"
                className={imgClassNames}
                image={coverImageUrl || boardPlaceholder}
                alt=""
              />
              <div className="narrowEndUserContentEntryCardText">{title}</div>
            </Grid>
          )}
          {!hasTitle && !coverImageUrl && (
            <div>
              <div className={imgClassNames} />
            </div>
          )}
        </Box>
      </Card>
    </div>
  );
};

RecipeCollectionCard.propTypes = {
  boardID: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  coverImageUrl: PropTypes.string.isRequired,
  onClickBoard: PropTypes.string.isRequired,
  isFavourite: PropTypes.bool.isRequired,
};

export default RecipeCollectionCard;
